import React, { useState } from 'react';
import winning from '../../../assets/winning-01.svg';
import stunhaul from '../../../assets/stunhaul.pdf';
import programmingHero from '../../../assets/programming-hero.pdf';
import ledp from '../../../assets/ledp.pdf';
import { motion } from "framer-motion";
import { PiCertificate } from 'react-icons/pi';
import {Helmet} from "react-helmet";

const Achievement = () => {

   const [isLoaded, setIsLoaded] = useState(false);
   const [isInView, setIsInView] = useState(false);

   const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
   const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

    return (
      <div className="p-4 sm:ml-20 lg:ml-48 md:ml-36 bg-gray-900">
      <Helmet>
        <title>My Certificate & Award</title>
        <meta name='portfolio' content='Mahabuba akter morsana - Award and Certificate' />
      </Helmet>
      <div className="p-6">
         <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-4 lg:mt-6 mt-4 items-center ">
            <div className='col-span-2 rounded text-left leading-relaxed'>
            <p className='text-[#976DB2] text-4xl mb-5'>AWARD CERTIFICATE</p>
            <div className="relative p-px my-3 overflow-hidden transition duration-300 transform border border-[#976db2] rounded shadow-sm hover:scale-105 group hover:shadow-xl">
               <div className="relative flex flex-col h-full p-2 bg-gray-800 rounded-sm lg:items-center lg:flex-row">
                  <div className="mb-6 mr-6 lg:mb-0">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-900 lg:w-12 lg:h-12">
                     <PiCertificate className="w-8 h-8 text-[#976db2]"></PiCertificate>
                  </div>
                  </div>
                  <div className="flex flex-col justify-between flex-grow">
                  <div>
                     <p className="mb-1 text-sm text-gray-300">
                     Stunhaul || Frontend Developer Intern ||June 2023 - August 2023 || Developed and maintained website using Tailwind, Javascript, Nodejs and Reactjs.
                     </p>
                  </div>
                  <a
                     href={stunhaul}
                     aria-label=""
                     target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-sm font-semibold transition-colors duration-200 text-[#976DB2] hover:text-deep-purple-800"
                  >
                     Learn more
                  </a>
                  </div>
               </div>
            </div>
            <div className="relative p-px mb-3 overflow-hidden transition duration-300 transform border border-[#976db2] rounded shadow-sm hover:scale-105 group hover:shadow-xl">
               <div className="relative flex flex-col h-full p-2 bg-gray-800 rounded-sm lg:items-center lg:flex-row">
                  <div className="mb-6 mr-6 lg:mb-0">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-900 lg:w-12 lg:h-12">
                                          <PiCertificate className="w-8 h-8 text-[#976db2]"></PiCertificate>
                  </div>
                  </div>
                  <div className="flex flex-col justify-between flex-grow">
                  <div>
                     <p className="mb-1 text-sm text-gray-300">
                     Achieved BlackBelt Certificate for Complete Web Development Course from Programming Hero (2023).
                     </p>
                  </div>
                  <a
                     href={programmingHero}
                     aria-label=""
                     target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-sm font-semibold transition-colors duration-200 text-[#976DB2] hover:text-deep-purple-800"
                  >
                     Learn more
                  </a>
                  </div>
               </div>
            </div>
            <div className="relative p-px mb-3 overflow-hidden transition duration-300 transform border border-[#976db2] rounded shadow-sm hover:scale-105 group hover:shadow-xl">
               <div className="relative flex flex-col h-full p-2 bg-gray-800 rounded-sm lg:items-center lg:flex-row">
                  <div className="mb-6 mr-6 lg:mb-0">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-900 lg:w-12 lg:h-12">
                                          <PiCertificate className="w-8 h-8 text-[#976db2]"></PiCertificate>
                  </div>
                  </div>
                  <div className="flex flex-col justify-between flex-grow">
                  <div>
                     <p className="mb-1 text-sm text-gray-300">
                     Awarded Laptop and Certified for Graphic Design Course from Learning and Earning Development Project, Bangladesh ICT Division (2022)
                     </p>
                  </div>
                  <a
                     href={ledp}
                     aria-label=""
                     target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-sm font-semibold transition-colors duration-200 text-[#976DB2] hover:text-deep-purple-800"
                  >
                     Learn more
                  </a>
                  </div>
               </div>
            </div>
            <div className="relative p-px mb-3 overflow-hidden transition duration-300 transform border border-[#976db2] rounded shadow-sm hover:scale-105 group hover:shadow-xl">
               <div className="relative flex flex-col h-full p-2 bg-gray-800 rounded-sm lg:items-center lg:flex-row">
                  <div className="mb-6 mr-6 lg:mb-0">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-900 lg:w-12 lg:h-12">
                                          <PiCertificate className="w-8 h-8 text-[#976db2]"></PiCertificate>
                  </div>
                  </div>
                  <div className="flex flex-col justify-between flex-grow">
                  <div>
                     <p className="mb-1 text-sm text-gray-300">
                     Achieved the First Position in the Divisional Composition Writing Competition on International Women's Day (2014).
                     </p>
                  </div>
                  <a
                     href="/"
                     aria-label=""
                     target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-sm font-semibold transition-colors duration-200 text-[#976DB2] hover:text-deep-purple-800"
                  >
                     Learn more
                  </a>
                  </div>
               </div>
            </div>
            <div className="relative p-px mb-3 overflow-hidden transition duration-300 transform border border-[#976db2] rounded shadow-sm hover:scale-105 group hover:shadow-xl">
               <div className="relative flex flex-col h-full p-2 bg-gray-800 rounded-sm lg:items-center lg:flex-row">
                  <div className="mb-6 mr-6 lg:mb-0">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-900 lg:w-12 lg:h-12">
                                          <PiCertificate className="w-8 h-8 text-[#976db2]"></PiCertificate>
                  </div>
                  </div>
                  <div className="flex flex-col justify-between flex-grow">
                  <div>
                     <p className="mb-1 text-sm text-gray-300">
                     Placed in Top Ten for Pran Chutney Advertisement Story Writing (2013).
                     </p>
                  </div>
                  <a
                     href="/"
                     aria-label=""
                     target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-sm font-semibold transition-colors duration-200 text-[#976DB2] hover:text-deep-purple-800"
                  >
                     Learn more
                  </a>
                  </div>
               </div>
            </div>
   
            </div>
            <motion.div
            className="col-span-1 flex items-center justify-center rounded"
             initial={false}
             animate={
                 isLoaded && isInView
                   ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                   : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
             }
             transition={{ duration: 0.5, delay: 0.5 }}
             viewport={{ once: true }}
             onViewportEnter={() => setIsInView(true)}
             >
             <img className="sm:w-80 lg:w-full md:w-96" src={winning} alt="" onLoad={() => setIsLoaded(true)} />
            </motion.div>
         </div>
      </div>
   </div>
    );
};

export default Achievement;